import { useMemo } from 'react';

import { ScheduleWorkingHours } from '@/types';
import {
  getActiveWorkingHours,
  getTimeZoneAbbreviation,
  getTodayWorkingHoursPeriod,
  resolveTimeZone,
} from '@/utils';

import { useGapCommerceStore, useSelectedStore } from './useSelectedStore';

export const useSelectedStoreTodayHours = (): string | null => {
  const { store: selectedStore } = useSelectedStore();
  const { store: gcStore } = useGapCommerceStore();

  return useMemo(() => {
    if (!selectedStore) return null;

    const pickupSchedule = gcStore?.pickup_schedules?.find(
      schedule => schedule?.stores_provider_id === selectedStore.short_name,
    );

    const activeWorkingHours = getActiveWorkingHours({
      adminWorkingHours:
        pickupSchedule?.working_hours as ScheduleWorkingHours[],
      configWorkingHours: selectedStore.working_hours,
    });

    const timeZone = resolveTimeZone(selectedStore.dispensary_time_zone);
    const todayPeriod = getTodayWorkingHoursPeriod(
      activeWorkingHours,
      timeZone,
    );
    if (!todayPeriod) return null;

    const isTimeRange = todayPeriod.includes('-');
    const tzAbbr = isTimeRange ? getTimeZoneAbbreviation(timeZone) : '';
    return tzAbbr ? `${todayPeriod} ${tzAbbr}` : todayPeriod;
  }, [selectedStore, gcStore]);
};
